/* Ducks is a modular redux model where you put a duck.js file
 in the same folder of the react component that uses it.
 More info: https://github.com/erikras/ducks-modular-redux
 */

// Action types
export const gtmEventTypes = {
  CLICK_LINK: 'WYSIWYG_CLICK_LINK',
}

// Action creators
export const gtmEvents = {
  [gtmEventTypes.CLICK_LINK]: ({CMSGroupGTM}) => ({
    ...CMSGroupGTM,
    type: gtmEventTypes.CLICK_LINK,
    event: 'reactjs.event',
    pageAction: CMSGroupGTM.action,
  }),
}



// WEBPACK FOOTER //
// ./src/store/gtm-events/wysiwyg-content-duck.js